import { ParticipantGrid } from 'types/Participants'

export const FILTER_DATE_FORMAT = 'DD MMM YY'
export const MONTH_FIRST_DATE_FORMAT = 'MM-DD-YYYY'
export const DAY_FIRST_DATE_FORMAT = 'DD/MM/YYYY'
export const isMobileView = window.innerWidth <= 768
export const RANGE_TYPES = {
  month: 'last_30_days',
  week: 'last_7_days',
  allTime: 'all_time',
  custom: 'custom',
}
export const ASC = 'asc'
export const DESC = 'desc'
export const COLUMNS: ParticipantGrid = {
  createdAt: 'createdAt',
}
export const DUPLICATE_TAG_ERR_STATUS = '422'
export const DEFAULT_CHAR_LIMIT = 32
export const PROJECT_STATUS_FILTER = [
  'draft',
  'published',
  'archived',
  'hidden',
]
export const QUERY_PARAM_PER_PAGE_9999 = 9999
export const QUERY_PARAM_PAGE_1 = 1
export const PARTICIPANT_TYPES_FILTER = [
  'anonymous',
  'unverified',
  'registered',
  'admin',
]
export const DEFAULT_PRM_ACTIVITIES_NOTES_COUNT = 30
export const DEFAULT_PRM_TOOLTIP_TRUNC_CHAR_LIMIT = 29
export const zIndexRaisedFilterCSS = {
  zIndex: 999,
  position: isMobileView ? 'relative' : 'absolute',
}
export const zIndexLoweredFilterCSS = {
  zIndex: 1,
  position: 'relative',
}
export const HelpDeskEnURL = 'https://helpdesk.bangthetable.com/en'
export const HelpDeskFrURL = 'https://helpdesk.bangthetable.com/fr'
export const PARTICIPANT_STATUS = {
  pendingActivation: 'pending_activation',
  active: 'active',
}
export const MAX_PARTICIPANT_TAGS_CHAR = 64

export const HTTP_STATUS = {
  noContentSuccessStatus: 204,
}
